import { useQuery } from "react-query";
import type { ApiError } from "@/react/config/CustomErrors";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { CssVariables } from "./constants";

const naturalSort = (a: string, b: string) =>
  a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });

export const DEFAULT_THEMES_QUERY_KEY = ["themes"];

interface ThemeOption {
  cssVariables: CssVariables;
  isCustom: boolean;
  name: string;
  value: number;
}

interface RawThemeData {
  css_variables: CssVariables;
  id: number;
  is_custom: boolean;
  theme_name: string;
  value: string;
}

export const useGetThemes = () =>
  useQuery<RawThemeData[], ApiError, ThemeOption[]>({
    queryKey: DEFAULT_THEMES_QUERY_KEY,
    queryFn: () => reactQueryGet(internalApi.settings.sites.themes.index()),
    select: (data: RawThemeData[]) =>
      data
        .map(theme => ({
          value: theme.id,
          cssVariables: theme.css_variables,
          name: theme.theme_name,
          isCustom: theme.is_custom,
        }))
        .sort((a, b) => {
          if (a.isCustom !== b.isCustom) {
            return a.isCustom ? -1 : 1;
          }

          return naturalSort(a.name, b.name);
        }),
    staleTime: 1000 * 60 * 60 * 24,
  });
